import { render, staticRenderFns } from "./WeaponComponent.vue?vue&type=template&id=8eaffd24&"
import script from "./WeaponComponent.vue?vue&type=script&lang=ts&"
export * from "./WeaponComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WeaponComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports